<template>
  <b-container
    fluid
    :class="[
      'main-layout p-0',
      {
        'h-100': isFullScreen
      }
    ]"
  >
    <header-section></header-section>
    <slot></slot>
    <footer-section v-if="!hideFooter"></footer-section>
  </b-container>
</template>
<script>
/**
 * ==================================================================================
 * Main page template
 * ==================================================================================
 **/

import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  components: {
    'header-section': Header,
    'footer-section': Footer
  },
  computed: {
    isFullScreen() {
      if (this.$route.meta && this.$route.meta.fullScreen) return true
      return false
    },

    hideFooter() {
      if (this.$route.meta && this.$route.meta.hideFooter) return true
      return false
    }
  }
}
</script>
<style scoped lang="scss">
.main-layout {
  background-color: var(--bg-color);
}
</style>
